<script setup lang="ts">

const whyChoseus = [
  {
    icon: 'uiw:safety',
    title: 'Segurança',
    content: 'Valorizamos a sua tranquilidade! Nosso compromisso é com a segurança dos seus dados e a autenticidade dos ingressos. Utilizamos tecnologia de ponta para proteger suas informações e garantir que cada ingresso adquirido em nosso site seja válido. Assim, você pode focar no que realmente importa: aproveitar cada momento do seu evento favorito, sem preocupações.'
  },
  {
    icon: 'mdi:heart-outline',
    title: 'Experiência',
    content: 'Sabemos que cada evento é uma experiência única. É por isso que nos dedicamos a tornar a compra de ingressos não apenas fácil, mas também segura e transparente. Com nossa plataforma intuitiva e um sistema de pagamento robusto, a venda de ingressos dos melhores shows, peças e festivais sem dor de cabeça.'
  },
  {
    icon: 'streamline-sharp:customer-support-1',
    title: 'Suporte',
    content: 'Nos escolher significa optar por um atendimento que realmente se importa com você. Nossa equipe está sempre pronta para ajudar, tirando dúvidas e oferecendo suporte rápido e eficiente. Queremos que sua jornada, desde a escolha do evento até a entrada no local, seja a melhor possível. Venha viver experiências incríveis com a gente!'
  },

  {
    icon: 'streamline-cyber:multi-platform-2',
    title: 'Plataforma',
    content: 'Produtor, sabemos que o sucesso do seu evento começa com uma bilheteria eficiente e sem complicações. Oferecemos uma plataforma robusta e intuitiva, desenhada para simplificar cada etapa da venda de ingressos. Desde a criação e divulgação do seu evento até o controle de acesso no dia, nossa tecnologia garante agilidade, segurança e uma gestão completa para que você foque no que faz de melhor: criar experiências inesquecíveis.'
  },
  {
    icon: 'mdi:report-finance',
    title: 'Relatórios',
    content: 'Entendemos os desafios de cada produção. Por isso, nossa plataforma vai além da simples venda. Oferecemos ferramentas de análise e relatórios detalhados que fornecem insights valiosos sobre seu público e o desempenho das vendas. Com esses dados em mãos, você pode tomar decisões estratégicas, otimizar campanhas e maximizar seus resultados, transformando cada ingresso vendido em um passo rumo ao sucesso do seu evento.'
  },
  {
    icon: 'mdi:partnership-outline',
    title: 'Parceria',
    content: 'Parceria é a chave para o crescimento, e é isso que oferecemos aos produtores. Conte com uma equipe de suporte dedicada, pronta para auxiliar em todas as suas necessidades, garantindo que sua operação de bilheteria seja fluida e sem imprevistos. Nos escolha e tenha ao seu lado um parceiro tecnológico que entende suas demandas e impulsiona o potencial do seu evento. Vamos juntos fazer cada show um sucesso?'
  }
]
</script>

<template>
  <section class="container mb-2 mb-xl-5 pb-lg-4" id="about-us">
    <h2 class="h3 mb-4">Por Que Nos Escolher?</h2>
    <div class="row">
      <div class="col-lg-4" v-for="(item, k) in whyChoseus" :key="k">
        <div class="card border-0">
          <div class="card-body">
            <Icon :icon="item.icon" class="icon-size-header mb-3 text-primary"/>
            <h3 class="h5 card-title pb-1">{{ item.title }}</h3>
            <p class="card-text">{{ item.content }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style>
#about-us .icon-size-header {
  font-size: 48px;
}
</style>
